<template>
    <BaseLightbox>
        <iframe
            :src="url"
            frameborder="0"
            hspace="0"
            vspace="0"
            scrolling="scroll"
            webkitallowfullscreen=""
            mozallowfullscreen=""
            allowfullscreen=""
        ></iframe>
    </BaseLightbox>
</template>

<script>
import BaseLightbox from "@/components/base/BaseLightbox.vue";

export default {
    props: {
        url: {
            type: String,
            required: true,
        },
    },
    components: {
        BaseLightbox,
    },
};
</script>

<style scoped lang="scss">
iframe {
    width: 100%;
    height: 60vh;
}
</style>
